import { useCallback } from 'react'

import { useMutation, ApolloError } from '@apollo/client'

import { MUTATION_UPDATE_TASK } from '@libs/apollo/mutations'

import { Task, TaskUpdateInput, MutationUpdateTaskArgs } from '@types'

interface Data {
  updateTask: Task
}

interface UseUpdateTaskProps {
  onCompleted?: () => void
}

export const useUpdateTask = (
  props?: UseUpdateTaskProps,
): {
  updateTask: (input: TaskUpdateInput) => Promise<void>
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [updateTask, { loading, error, data }] = useMutation<Data, MutationUpdateTaskArgs>(MUTATION_UPDATE_TASK, {
    notifyOnNetworkStatusChange: true,
  })

  const _updateTask = useCallback(
    async (input: TaskUpdateInput): Promise<void> => {
      await updateTask({ variables: { input }, onCompleted: props?.onCompleted })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateTask],
  )

  return { updateTask: _updateTask, loading, error, data }
}
